/**
 * AIRegenerationModal Component for LOOPINO AI Mobile
 * Unified modal for AI regeneration options with platform design consistency
 */

import React, { useState, useEffect, useCallback, useMemo } from 'react';
import './AIRegenerationModal.css';
import useLanguage from '../../../hooks/useLanguage';

// AI Icon component
const AIIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.56791 18.8123V17.9563H1.71194C1.23925 17.9563 0.856061 17.573 0.855972 17.1003C0.855972 16.6276 1.2392 16.2444 1.71194 16.2444H2.56791V15.3884C2.56791 14.9157 2.95119 14.5325 3.42389 14.5324C3.89666 14.5324 4.27986 14.9156 4.27986 15.3884V16.2444H5.13583C5.6086 16.2444 5.9918 16.6276 5.9918 17.1003C5.99171 17.573 5.60855 17.9563 5.13583 17.9563H4.27986V18.8123C4.27983 19.285 3.89664 19.6683 3.42389 19.6683C2.95121 19.6682 2.56794 19.285 2.56791 18.8123ZM10.4767 4.80819C10.6996 4.77883 10.927 4.79315 11.1455 4.85199H11.1446C11.5422 4.95852 11.8004 5.23185 11.9627 5.47207C12.1242 5.71114 12.2481 6.00066 12.3529 6.29619C12.5623 6.88697 12.7703 7.72584 13.0287 8.7586L13.1272 9.12687C13.1277 9.1282 13.1278 9.12959 13.1282 9.13085C13.1298 9.13146 13.1315 9.13219 13.1332 9.13284C13.2028 9.15873 13.3021 9.18814 13.4955 9.24332L14.7028 9.59467C15.0616 9.70418 15.3747 9.80788 15.6344 9.91118C15.8954 10.015 16.1552 10.1383 16.3729 10.2984C16.5953 10.4619 16.832 10.7075 16.9343 11.0667L16.9632 11.1822C17.0206 11.4541 17.0108 11.7369 16.9343 12.0053C16.832 12.3646 16.5953 12.6102 16.3729 12.7737C16.1552 12.9337 15.8954 13.0571 15.6344 13.1609C15.3747 13.2642 15.0616 13.3679 14.7028 13.4774L13.4955 13.8287C13.3017 13.884 13.2026 13.9134 13.1332 13.9392C13.1316 13.9398 13.1297 13.9396 13.1282 13.9402C13.1277 13.9417 13.1277 13.9436 13.1272 13.9452C13.1037 14.0159 13.0776 14.1158 13.0287 14.3125V14.3135C12.7703 15.3462 12.5623 16.1851 12.3529 16.7759C12.2482 17.0712 12.124 17.36 11.9627 17.599C11.8004 17.8393 11.5424 18.1135 11.1446 18.2201L11.1436 18.2191C10.8524 18.2974 10.5448 18.2978 10.2537 18.2191V18.2181C9.85746 18.1108 9.59965 17.839 9.43758 17.599C9.27623 17.36 9.15315 17.0703 9.04842 16.7749C8.83905 16.1842 8.62996 15.3461 8.3716 14.3135V14.3125C8.32287 14.1171 8.29666 14.0169 8.27306 13.9462C8.27238 13.9441 8.27171 13.9421 8.27107 13.9402C8.26992 13.9398 8.26831 13.9397 8.26709 13.9392C8.19746 13.9134 8.09824 13.8838 7.9048 13.8287H7.9038C7.01716 13.5751 6.28619 13.3673 5.76686 13.1609C5.50565 13.057 5.24523 12.9337 5.02734 12.7737C4.80497 12.6104 4.56776 12.3654 4.46499 12.0063V12.0053C4.37762 11.6987 4.37762 11.3734 4.46499 11.0667V11.0657L4.50978 10.9364C4.62696 10.6467 4.83277 10.4413 5.02734 10.2984C5.24523 10.1383 5.50565 10.015 5.76686 9.91118C6.28619 9.70471 7.01714 9.49701 7.9038 9.24332L8.26709 9.13284C8.26847 9.13233 8.26978 9.13134 8.27107 9.13085C8.27152 9.12954 8.2726 9.12826 8.27306 9.12687C8.29659 9.05618 8.32263 8.95638 8.3716 8.7596V8.7586L8.72792 7.36118C8.83852 6.94875 8.94375 6.5915 9.04842 6.29619C9.15315 6.00074 9.27615 5.71108 9.43758 5.47207C9.59972 5.23206 9.85767 4.95878 10.2547 4.85199L10.4767 4.80819ZM10.6618 6.8685C10.4867 7.36268 10.3008 8.10258 10.0328 9.17365C9.96005 9.46604 9.87841 9.86432 9.63366 10.1819L9.63167 10.1849C9.55326 10.2858 9.46375 10.3776 9.36493 10.4586L9.36393 10.4576C9.05572 10.7115 8.65922 10.8071 8.37359 10.8886L8.37459 10.8896C7.44827 11.1546 6.81882 11.3347 6.39888 11.5017C6.37093 11.5128 6.34557 11.5253 6.32125 11.5355C6.34567 11.5459 6.37079 11.5592 6.39888 11.5704C6.81882 11.7373 7.44826 11.9174 8.37459 12.1825H8.37359C8.62903 12.2552 8.96143 12.3366 9.24648 12.5249L9.36493 12.6125L9.36791 12.6154L9.50925 12.7468C9.55377 12.7931 9.59654 12.8411 9.63565 12.8921H9.63466C9.87752 13.2082 9.95977 13.6057 10.0328 13.8984L10.3821 15.267C10.4841 15.6477 10.5742 15.9565 10.6618 16.2036C10.6741 16.2383 10.6882 16.2699 10.6996 16.3001C10.7111 16.2698 10.7261 16.2384 10.7385 16.2036C10.9136 15.7094 11.0995 14.9695 11.3675 13.8984C11.4402 13.6061 11.522 13.2078 11.7666 12.8902L11.7686 12.8872L11.895 12.7428C11.9381 12.6986 11.9837 12.6568 12.0314 12.6174L12.1508 12.5279C12.4376 12.3366 12.7736 12.2544 13.0257 12.1825L14.2042 11.8391C14.5295 11.74 14.7917 11.6538 15.0014 11.5704C15.0291 11.5593 15.0539 11.5457 15.078 11.5355C15.054 11.5254 15.029 11.5127 15.0014 11.5017C14.7916 11.4183 14.5296 11.3311 14.2042 11.232L13.0257 10.8896C12.7349 10.8066 12.3427 10.7116 12.0354 10.4596L12.0324 10.4566C11.9345 10.3755 11.8462 10.2836 11.7686 10.1829V10.1839C11.5836 9.94538 11.4913 9.65879 11.4262 9.40854L11.3675 9.17365C11.0995 8.10255 10.9136 7.36267 10.7385 6.8685C10.726 6.83333 10.7112 6.80151 10.6996 6.77095C10.6881 6.80138 10.6742 6.8335 10.6618 6.8685ZM2.13993 8.96762V7.68366H0.855972C0.3832 7.68366 0 7.30046 0 6.82769C7.73956e-05 6.35498 0.383248 5.97172 0.855972 5.97172H2.13993V4.68776C2.13993 4.21503 2.52319 3.83186 2.9959 3.83179C3.46867 3.83179 3.85187 4.21499 3.85187 4.68776V5.97172H5.13583C5.60855 5.97172 5.99172 6.35498 5.9918 6.82769C5.9918 7.30046 5.6086 7.68366 5.13583 7.68366H3.85187V8.96762C3.85187 9.44039 3.46867 9.82359 2.9959 9.82359C2.52319 9.82351 2.13993 9.44034 2.13993 8.96762Z" fill="currentColor"/>
  </svg>
);

// Close Icon component
const CloseIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Magic wand icon for regeneration options
const MagicIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="m15 4.5-4 4L7 10l4 4 4-1.5L17 14l-4-4 4-4-2-1.5Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="m9 15 2 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="m13 9 2 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="m9 7 2 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="m13 17 2 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Image icon
const ImageIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2" stroke="currentColor" strokeWidth="2"/>
    <circle cx="9" cy="9" r="2" stroke="currentColor" strokeWidth="2"/>
    <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" stroke="currentColor" strokeWidth="2"/>
  </svg>
);

// Text icon
const TextIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="currentColor" strokeWidth="2"/>
    <polyline points="14,2 14,8 20,8" stroke="currentColor" strokeWidth="2"/>
    <line x1="16" y1="13" x2="8" y2="13" stroke="currentColor" strokeWidth="2"/>
    <line x1="16" y1="17" x2="8" y2="17" stroke="currentColor" strokeWidth="2"/>
    <polyline points="10,9 9,9 8,9" stroke="currentColor" strokeWidth="2"/>
  </svg>
);

// Regeneration type configurations
const TYPE_ICONS = {
  image: ImageIcon,
  text: TextIcon,
  full: MagicIcon,
  blocks: MagicIcon
};

const AIRegenerationModal = ({
  isOpen,
  onClose,
  type = 'full', // 'image', 'text', 'full'
  post,
  imageIndex = null, // for specific image regeneration
  onRegenerate,
  isRegenerating = false,
  extraContent = null
}) => {
  const { t } = useLanguage();
  const [prompt, setPrompt] = useState('');
  const [isVisible, setIsVisible] = useState(false);

  const configMap = useMemo(() => ({
    image: {
      title: t('postReview.aiModal.types.image.title'),
      description: t('postReview.aiModal.types.image.description'),
      placeholder: t('postReview.aiModal.types.image.placeholder'),
      icon: TYPE_ICONS.image
    },
    text: {
      title: t('postReview.aiModal.types.text.generateTitle', { defaultValue: 'Genera descrizione' }),
      description: t('postReview.aiModal.types.text.description'),
      placeholder: t('postReview.aiModal.types.text.placeholder'),
      icon: TYPE_ICONS.text
    },
    full: {
      title: t('postReview.aiModal.types.full.title'),
      description: t('postReview.aiModal.types.full.description'),
      placeholder: t('postReview.aiModal.types.full.placeholder'),
      icon: TYPE_ICONS.full
    },
    blocks: {
      title: t('postReview.aiModal.types.blocks.title', { defaultValue: 'Rigenera blocchi' }),
      description: t('postReview.aiModal.types.blocks.description', { defaultValue: 'Aggiorna i blocchi del prompt senza generare nuove immagini.' }),
      placeholder: t('postReview.aiModal.types.blocks.placeholder', { defaultValue: 'Descrivi come vuoi aggiornare i blocchi del prompt...' }),
      icon: TYPE_ICONS.blocks
    }
  }), [t]);

  const config = configMap[type] || configMap.full;

  // Handle modal visibility with animation
  useEffect(() => {
    if (isOpen) {
      setIsVisible(true);
      // Prevent body scroll
      document.body.style.overflow = 'hidden';
    } else {
      setIsVisible(false);
      // Restore body scroll
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  // Reset state when modal opens
  useEffect(() => {
    if (isOpen) {
      setPrompt('');
    }
  }, [isOpen, type]);

  // Handle regeneration submit
  const handleSubmit = useCallback(async () => {
    if (!prompt.trim() || !onRegenerate) {
      console.warn('[AIRegenerationModal] Cannot submit: no prompt or no handler');
      return;
    }

    const regenerationData = {
      type,
      prompt: prompt.trim(),
      post,
      imageIndex
    };

    // Close immediately; parent handles loading UI.
    onClose();

    try {
      await onRegenerate(regenerationData);
    } catch (error) {
      console.error('[AIRegenerationModal] Regeneration failed:', error);
    }
  }, [prompt, type, post, imageIndex, onRegenerate, onClose]);

  // Handle overlay click
  const handleOverlayClick = useCallback((e) => {
    if (e.target === e.currentTarget && !isRegenerating) {
      onClose();
    }
  }, [onClose, isRegenerating]);

  // Handle escape key
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && !isRegenerating) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen, onClose, isRegenerating]);

  if (!isOpen) return null;

  return (
    <div 
      className={`ai-regeneration-modal-overlay ${isVisible ? 'visible' : ''}`}
      onClick={handleOverlayClick}
    >
      <div className={`ai-regeneration-modal ${isVisible ? 'visible' : ''}`}>
        {/* Header */}
        <div className="ai-modal-header">
          <div className="ai-modal-title-section">
            <div>
              <h2 className="ai-modal-title">{config.title}</h2>
              <p className="ai-modal-description">{config.description}</p>
            </div>
          </div>
          <button
            className="ai-modal-close"
            onClick={onClose}
            disabled={isRegenerating}
            aria-label={t('postReview.aiModal.aria.close')}
          >
            <CloseIcon size={20} />
          </button>
        </div>

        {/* Content */}
        <div className="ai-modal-content">
          {/* Prompt Input */}
          <div className="ai-modal-input-section">
            <label htmlFor="ai-prompt" className="input-label">
              {t('postReview.aiModal.labels.prompt')}
            </label>
            <textarea
              id="ai-prompt"
              className="ai-modal-textarea"
              value={prompt}
              onChange={(e) => setPrompt(e.target.value)}
              placeholder={config.placeholder}
              disabled={isRegenerating}
              rows={4}
            />
          </div>
          {extraContent && (
            <div className="ai-modal-extra">
              {extraContent}
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="ai-modal-footer">
          <button
            className="ai-modal-button primary"
            onClick={handleSubmit}
            disabled={!prompt.trim() || isRegenerating}
          >
            {isRegenerating ? (
              <>
                <div className="ai-loading-spinner" />
                {t('postReview.aiModal.status.generating')}
              </>
            ) : (
              <>
                <AIIcon size={16} />
                {type === 'text'
                  ? t('postReview.aiModal.actions.generate', { defaultValue: 'Genera' })
                  : t('postReview.aiModal.actions.submit', { defaultValue: 'Rigenera' })}
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AIRegenerationModal; 
